import React, { Component } from 'react';
import { connect } from 'react-redux';

class EventFeature extends Component {

	renderEventFeature() {
		function renderRegistrationLink( feature ) {
			if ( feature.registration === true ) {
				return (
					<a href={ feature.registration_url } className="btn btn-primary" data-imiscode={feature.imis_code}>
						Register Now
						<span className="sr-only"> for { feature.title }</span>
					</a>
				);
			}

			return null;
		}

		function renderChildCategory( feature ) {
			if ( !feature.parent_child_cats || !feature.parent_child_cats.child ) {
				return;
			}

			if ( feature.parent_child_cats.child.slug.length ) {
				return (
					<span><a href={ feature.child_category_link }>
						{ feature.parent_child_cats.child.name }
					</a> | </span>
				);
			}
		}

		function renderCityLink( feature ) {
			if ( feature.city_link ) {
				return (
					<a href={ feature.city_link } className="entry-city"> { feature.city.name }</a>
				);
			}
		}

		function renderCustomPageThumbnail( feature ) {
			if ( feature.thumbnail !== false ) {
				return (
					<img width="100%" height="auto" src={ feature.thumbnail } className="attachment-single_post size-single_post wp-post-image" alt="" />
				);
			}
		}

		let filteredFeatures = this.props.features;

		if ( Array.isArray( filteredFeatures ) && filteredFeatures.length ) {
			if ( filteredFeatures[ 0 ][ 'custom_page_id' ] ) {

				let customFeaturedPage = filteredFeatures[ 0 ];
				return (
					<div className="col-xs-12">
						{ renderCustomPageThumbnail( customFeaturedPage ) }

						<div className="blue-hero-left col-lg-6">
							<div className="entry-meta">
								<div className="category-icon-link">
									<span className="category-icon category-events" aria-hidden="true"> </span>
								</div>
							</div>
							<a href={ customFeaturedPage.link }>
								<h2 className="entry-title">
									<span>{ customFeaturedPage.title }</span>
								</h2>
							</a>
							<a href={ customFeaturedPage.link } className="btn btn-primary featured-splash-page-btn">
								Details
							</a>
						</div>
					</div>
				);
			} else {

				return filteredFeatures.map( ( feature, ind ) => {
					return (
						<div className="col-xs-12">
							<img width="100%" height="auto" src={ feature.thumbnail } className="attachment-single_post size-single_post wp-post-image" alt="" />
							<div className="blue-hero-left col-lg-6">
								<div className="entry-meta">
									{ renderChildCategory( feature ) }
									<span className="published-date">{ feature.formatted_date }</span>

									<div className="category-icon-link">
										<span className="category-icon category-events" aria-hidden="true"> </span>
									</div>
									{ renderCityLink( feature ) }
								</div>
								<a href={ feature.link } data-imiscode={feature.imis_code} className="entry-title-link">
									<h2 className="entry-title">
										<span>{ feature.title }</span></h2>
								</a>
								<a href={ feature.link } className="btn btn-primary" data-imiscode={feature.imis_code}>
									Event Details
									<span className="sr-only"> for { feature.title }</span>
								</a>
								{ renderRegistrationLink( feature ) }
							</div>
						</div>
					);
				} );
			}
		} else {
			return [ 0 ].map( ind => this.getEmptyFeature( ind ) );
		}
	}

	getEmptyFeature( ind ) {
		return (<div className="col-xs-12">
				<div className="blue-hero-left col-lg-6">
					&nbsp;
				</div>
			</div>
		);
	}

	render() {
		return (<div className="blue-hero-single row no-gutter">
				{ this.renderEventFeature() }
			</div>
		);
	}
}

function mapStateToProps( { features } ) {
	return { features };
}

export default connect( mapStateToProps, null )( EventFeature );
